import { NOTIFICATION_TYPES, NOTIFICATION_TYPE_NAME_MAP } from '../../constants';
/**
 * Get text that should override body text of a notification if applicable
 */
export const getContextText = browserNotification => {
  // We show the sanitized value of the mention context item
  if (browserNotification.type !== NOTIFICATION_TYPE_NAME_MAP[NOTIFICATION_TYPES.MENTION]) {
    return null;
  }
  const mentionContext = browserNotification.context.find(context => context.key === 'mention');
  if (mentionContext) {
    // Strip html from string
    return `${mentionContext.value}`.replace(/<[^>]+>/g, '');
  }
  return null;
};